import React from 'react'

import EagleImg from './img/eagle.png'

export const AiAbout: React.FC = () => {
    return (
        <>
            <h1 className="font-bold text-2xl mt-10 text-center">
                Встроенный справочник с ИИ
            </h1>
            <div className="mt-4 grid md:grid-cols-2 gap-4 text-sm">
                <div className="card_item card_item_light font-bold content-center">
                    Больше не нужно искать коды ОКПД2 и проверять на ограничения
                    и требования, умный справочник подскажет все!
                </div>
                <div className="card_item card_item_light font-bold flex !p-0 items-center">
                    <div className="p-6">
                        Все требования по нацрежиму согласно ПП №1875
                    </div>
                    <img src={EagleImg} />
                </div>
                <div className="p-2 pb-4 border-b-2">
                    <b>ИИ подберет код ОКПД2 по наименованию</b>
                    <br />
                    Достаточно ввести наименование ТРУ и ИИ подберет подходящий
                    код ОКПД2
                </div>
                <div className="p-2 pb-4 border-b-2">
                    <b>Подсказка запретов</b>
                    <br />
                    NOXSYS покажет товары, работы, услуги в отношении которых
                    установлен запрет
                </div>
                <div className="p-2 pb-4 border-b-2">
                    <b>Проверка на электронную форму</b>
                    <br />
                    NOXSYS подскажет, когда закупка осуществляется в электронной
                    форме
                </div>
                <div className="p-2 pb-4 border-b-2">
                    <b>Подсказка ограничений</b>
                    <br />
                    NOXSYS покажет товары, работы, услуги в отношении которых
                    установлены ограничения
                </div>
                <div className="p-2 pb-4 border-b-2">
                    <b>Проверка на ограничения по субъектам МСП</b>
                    <br />
                    NOXSYS подскажет, когда закупка осуществляется только у
                    субъектов МСП
                </div>
                <div className="p-2 pb-4 border-b-2">
                    <b>Подсказка минимальной доли</b>
                    <br />
                    NOXSYS покажет минимальную обязательную долю закупок
                    товаров, работ, услуг
                </div>
            </div>
        </>
    )
}
